import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import DashboardLayout from '@/components/layout/DashboardLayout';
import { LayoutDashboard, Users, Truck, ShieldAlert, Map, Mail, Settings, BarChart, MessageSquare, Eye, Coins } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/use-toast';
import { Badge } from '@/components/ui/badge';
import Divider from '@/components/ui/divider';
import { adminSidebarLinks } from '@/config/adminSidebarLinks';

const mockDisputes = [
  { id: 1, missionId: '#M1982', client: 'Client Express', subject: 'Marchandise endommagée', date: '2025-10-09', status: 'open' },
  { id: 2, missionId: '#M1975', client: 'Mamadou Diallo', subject: 'Retard de livraison', date: '2025-10-08', status: 'open' },
  { id: 3, missionId: '#M1950', client: 'Commerce SARL', subject: 'Paiement non reçu', date: '2025-10-07', status: 'resolved' },
];

const AdminSupport = () => {
  const handleNotImplemented = () => toast({ title: '🚧 Bientôt disponible!' });

  const getStatusBadge = (status) => {
    const statusMap = {
      open: 'bg-red-500/20 text-red-400 border-red-500/30',
      resolved: 'bg-green-500/20 text-green-400 border-green-500/30',
    };
    return <Badge className={`capitalize ${statusMap[status]}`}>{status === 'open' ? 'Ouvert' : 'Résolu'}</Badge>;
  };

  return (
    <>
      <Helmet><title>Support & Litiges - LogiConnect</title></Helmet>
      <DashboardLayout sidebarLinks={adminSidebarLinks}>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-6">Support & Litiges</h1>
        
        {/* Divider */}
        <Divider variant="gradient" icon={ShieldAlert} label="Litiges en Cours" />
        
        <div className="bg-card border border-border rounded-xl">
          <div className="p-6 border-b border-border"><h2 className="text-xl font-semibold text-foreground">Litiges en cours</h2></div>
          <div className="p-6 space-y-4">
            {mockDisputes.filter(d => d.status === 'open').map((item) => (
              <div key={item.id} className="bg-muted p-4 rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center gap-4 hover:bg-accent">
                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-2">
                    <span className="font-semibold text-lg text-foreground">Mission {item.missionId}</span>
                    {getStatusBadge(item.status)}
                  </div>
                  <p className="text-foreground">Sujet: {item.subject}</p>
                  <p className="text-sm text-muted-foreground">Client: {item.client}</p>
                </div>
                <div className="flex gap-2 self-end md:self-center">
                  <Button variant="outline" onClick={handleNotImplemented}><Eye className="w-4 h-4 mr-2" /> Détails</Button>
                  <Button className="bg-secondary text-secondary-foreground font-semibold" onClick={handleNotImplemented}><MessageSquare className="w-4 h-4 mr-2" /> Résoudre</Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </DashboardLayout>
    </>
  );
};

export default AdminSupport;
